var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdduser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2972",
    "data-name": "Group 2972",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.795,
    height: 18.143,
    viewBox: "0 0 15.795 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 15.795,
    height: 18.143,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2971",
    "data-name": "Group 2971",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M64.434,0a4.221,4.221,0,0,1,4.195,4.211,4.205,4.205,0,1,1-8.411-.065A4.221,4.221,0,0,1,64.434,0m-.019,1.427a2.743,2.743,0,0,0-2.749,2.786A2.757,2.757,0,0,0,67.18,4.2a2.744,2.744,0,0,0-2.765-2.77",
    transform: "translate(-56.047 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M4.5,149.2H.779A.7.7,0,0,1,0,148.427c0-.45,0-.9,0-1.349a6.274,6.274,0,0,1,4.932-6.127,5.586,5.586,0,0,1,1.228-.137c.965.005,1.93,0,2.895,0a.714.714,0,1,1-.008,1.423c-.871,0-1.741-.006-2.612,0a4.959,4.959,0,0,0-2.675.713,4.72,4.72,0,0,0-2.3,3.811c-.019.246-.025.492-.039.738-.011.217.052.286.278.284,1.654-.009,3.308-.005,4.962-.005.53,0,1.059,0,1.589,0a.712.712,0,1,1,0,1.422q-1.872,0-3.744,0",
    transform: "translate(0 -131.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M163.841,155.7c0-.758,0-2.7,0-3.454a.748.748,0,0,1,.719-.832.761.761,0,0,1,.753.811c.009.868,0,2.917,0,3.785q0,.971,0,1.943a.818.818,0,0,1-.366.758.668.668,0,0,1-.73.027.694.694,0,0,1-.377-.631c0-.8,0-1.6,0-2.406",
    transform: "translate(-152.494 -140.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M124.046,195.8h-2.274a.748.748,0,0,1-.832-.719.761.761,0,0,1,.811-.753c.868-.009,1.737,0,2.605,0,.648,0,2.475,0,3.123,0a.818.818,0,0,1,.758.365.668.668,0,0,1,.027.73.694.694,0,0,1-.631.377c-.8,0-2.784,0-3.586,0",
    transform: "translate(-112.564 -180.862)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdduser);
export default __webpack_public_path__ + "static/media/icon_adduser.2dd7158d63293393be1bf0096eacad6e.svg";
export { ForwardRef as ReactComponent };